import { ErrorMessage, Form, Formik } from "formik";
import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import messages from "../../../assets/locale/messages";
import Input from "../../../components/Input";
import Modal from "../../../components/Modal";
import { createProgramRequest } from "../../../store/Programs/actions";
import PropTypes from "prop-types";
import DatePicker from "../../../components/DatePicker";
import moment from "moment";
import { validationAddProgramSchema } from "./validation";
import Upload from "../../../components/Upload";
import CancelIcon from "@mui/icons-material/Cancel";
import styles from "./ProgramForm.module.scss";
import { uploadToS3 } from "../../../utils/S3";
import { showHideLoader } from "../../../store/Loader/actions";
import { getLocalORPublicSrc } from "../../../utils/Constants";
import Switch from "../../../components/Switch";
function ProgramForm({ mode, setFormModalOpen, isOpen }) {
  const logoRef = useRef();
  const [previewImage, setPreviewImage] = useState(null);
  const { meta } = useSelector((state) => state.programs);
  const lang = useSelector((state) => state.locale.lang);
  const { mode: stringMode } = mode;

  const {
    programs: { addTitle, editTitle, programNameLabel }
  } = messages[lang];
  const formRef = useRef();
  const dispatch = useDispatch();

  const handleModalSubmit = () => {
    if (formRef.current) {
      formRef.current.handleSubmit();
    }
  };

  const handleSubmit = async (values) => {
    try {
      dispatch(showHideLoader(true));
      values.start_date = moment(values.start_date).format(
        "DD-MM-YYYY"
      );
      values.end_date = moment(values.end_date).format("DD-MM-YYYY");
      if (values?.photo_url) {
        const { link } = await uploadToS3(
          "public",
          values?.photo_url,
          values?.photo_url.name
        );
        values.photo_url = link;
      }
      dispatch(
        createProgramRequest({
          program: values,
          page: meta?.currentPage
        })
      );
      setFormModalOpen(false);
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  return (
    <Modal
      title={stringMode === "add" ? addTitle : editTitle}
      hasActions={true}
      isOpen={isOpen}
      handleModalSubmit={handleModalSubmit}
      handleModalCancel={() => setFormModalOpen(false)}
    >
      <Formik
        initialValues={{
          name: "",
          start_date: "",
          end_date: "",
          photo_url: null,
          total_users_limit: "",
          book_threads_enabled: false
        }}
        innerRef={formRef}
        onSubmit={handleSubmit}
        validationSchema={validationAddProgramSchema}
      >
        {({ values, setFieldValue }) => {
          console.log("values", values);
          return (
            <Form>
              <div
                className={styles.upload_container}
                style={{
                  display: values?.photo_url ? "flex" : "block"
                }}
              >
                <Upload
                  ref={logoRef}
                  isMultiple={false}
                  // onChange={() => {}}
                  isImage={true}
                  setFieldValue={setFieldValue}
                  label="Upload Logo"
                  name="photo_url"
                  accept="image/*"
                  handlePreviewSrc={setPreviewImage}
                />
                {previewImage && (
                  <div className={styles.logo_preview}>
                    <CancelIcon
                      onClick={() => {
                        setFieldValue("photo_url", "");
                        setPreviewImage(null);
                        if (logoRef.current)
                          logoRef.current.value = "";
                      }}
                      className={styles.delete_icon}
                    />
                    <img
                      src={getLocalORPublicSrc(previewImage)}
                      alt="logo"
                    />
                  </div>
                )}
                <div></div>
              </div>

              <Input
                type="text"
                name="name"
                label={programNameLabel}
                isRequired={true}
              />
              <Input
                name="total_users_limit"
                type={"number"}
                isNumber={true}
                label={"Limit of students"}
                isRequired={true}
              />
              <DatePicker
                format="dd-MM-yyyy"
                placeholder={"start date"}
                setFieldValue={setFieldValue}
                name="start_date"
              />
              <ErrorMessage
                component="div"
                className="error-msg"
                name={"start_date"}
              />
              <DatePicker
                format="dd-MM-yyyy"
                style={{ marginTop: "20px" }}
                placeholder={"end date"}
                setFieldValue={setFieldValue}
                name="end_date"
              />
              <ErrorMessage
                component="div"
                className="error-msg"
                name={"end_date"}
              />
              <Switch
                name="book_threads_enabled"
                label={"book threads enabled"}
              />
            </Form>
          );
        }}
      </Formik>
    </Modal>
  );
}

ProgramForm.propTypes = {
  mode: PropTypes.object,
  setFormModalOpen: PropTypes.func,
  isOpen: PropTypes.bool
};

export default ProgramForm;
